import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import SyncEventsManager from './SyncEventsManager';

type SyncEventsDialogProps = {
  open: boolean;
  onClose: () => void;
};

const SyncEventsDialog: FC<SyncEventsDialogProps> = (props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Synchronization Events</DialogTitle>
      <DialogContent>
        <SyncEventsManager />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SyncEventsDialog;
